import { Spinner } from 'react-bootstrap';

export const NewRequestPlaceholder = () => {
    return (
        <div className='w-100 h-100 background-white d-flex justify-content-center align-items-center'>
            <Spinner animation='border' />
        </div>
    );
};
